import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { updateGrade } from "./api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { ...rest } = values;
  return {
    ...Object.fromEntries(
      Object.entries(rest).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };
}

export function useUpdateGrade() {
  return useMutation({
    mutationFn: async ({ item, gradeId }) => {
      const payload = buildPayload(item);
      const response = await updateGrade({ item: payload, gradeId });
      return response;
    },
    onSuccess: () => {
      toast.success("Grade Updated Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
